import {
    DYNAMIC_SECTION_SLUGS,
    STRUCTURED_SECTION_SLUGS,
} from '@src/components/product_pages/data';

import { cleanTimestampsParams } from './common';

const mapShowInMenuToBoolean = (value) => value === true || value === 'true';

const mapSectionForUpdate = (section) => {
    const isDynamic = DYNAMIC_SECTION_SLUGS.includes(section.slug);
    const isStructured = STRUCTURED_SECTION_SLUGS.includes(section.slug);

    const mapped = {
        slug: section.slug,
        status: section.status,
        title: section.title || '',
        showInMenu: mapShowInMenuToBoolean(section.showInMenu) ? 'true' : 'false',
    };

    if (isDynamic) {
        mapped.data = {};
        return mapped;
    }

    if (isStructured) {
        mapped.data = section.data || {};
        return mapped;
    }

    mapped.data = section.data || {};
    return mapped;
};

const mapProductPageParams = (isCreate, params) => {
    return new Promise((resolve) => {
        if (isCreate) {
            resolve({
                product_page: {
                    product_id: params.product_id,
                    status: params.status || 'draft',
                },
            });
            return;
        }

        const cleaned = cleanTimestampsParams(params);
        const content = cleaned.content || {};
        const sections = (content.sections || []).map(mapSectionForUpdate);

        resolve({
            product_page: {
                status: cleaned.status,
                content: {
                    sections,
                },
            },
        });
    });
};

export { mapProductPageParams };
